export default "__VITE_ASSET__f9cbceaa__"